import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);

  return (
    <section className="w-full py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选优质内容，不容错过的深度好文</p>
          </div>
          <Link
            to="/category/entertainment"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 亚洲在线`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-white text-xs rounded-full">
                  {article.categoryLabel}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}